import { useEffect, useState } from 'react';

/**
 * Hoãn giá trị lại `delay` ms — dùng cho ô tìm kiếm để không gọi API mỗi ký tự.
 * Thay cho cặp `searchTimer` + `clearTimeout` thủ công ở bản gốc.
 */
export function useDebouncedValue<T>(value: T, delay = 350): T {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const timer = window.setTimeout(() => setDebounced(value), delay);
		return () => window.clearTimeout(timer);
	}, [value, delay]);

	return debounced;
}
